import { render, staticRenderFns } from "./list-title.vue?vue&type=template&id=bc161d7a"
import script from "./list-title.vue?vue&type=script&lang=js"
export * from "./list-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports